// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file protobuf/journey/data/categories/authentication_category.proto (package od_protos.journey.data.categories, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { StringValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import { file_protobuf_journey_data_options_options } from "../options/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file protobuf/journey/data/categories/authentication_category.proto.
 */
export const file_protobuf_journey_data_categories_authentication_category: GenFile = /*@__PURE__*/
  fileDesc("Cj5wcm90b2J1Zi9qb3VybmV5L2RhdGEvY2F0ZWdvcmllcy9hdXRoZW50aWNhdGlvbl9jYXRlZ29yeS5wcm90bxIhb2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzIuQlChZBdXRoZW50aWNhdGlvbkNhdGVnb3J5ElUKBWxvZ2luGAEgASgLMkQub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLkF1dGhlbnRpY2F0aW9uQ2F0ZWdvcnkuTG9naW5FdmVudEgAEmQKDWxvZ2luX2ZhaWx1cmUYAiABKAsySy5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuQXV0aGVudGljYXRpb25DYXRlZ29yeS5Mb2dpbkZhaWx1cmVFdmVudEgAEmMKDHJlZ2lzdHJhdGlvbhgDIAEoCzJLLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5BdXRoZW50aWNhdGlvbkNhdGVnb3J5LlJlZ2lzdHJhdGlvbkV2ZW50SAAScgoUcmVnaXN0cmF0aW9uX2ZhaWx1cmUYBCABKAsyUi5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuQXV0aGVudGljYXRpb25DYXRlZ29yeS5SZWdpc3RyYXRpb25GYWlsdXJlRXZlbnRIABJwChNjbGllbnRfcmVnaXN0cmF0aW9uGAUgASgLMlEub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLkF1dGhlbnRpY2F0aW9uQ2F0ZWdvcnkuQ2xpZW50UmVnaXN0cmF0aW9uRXZlbnRIABJsChFjYWxsYmFja19yZWNlaXZlZBgGIAEoCzJPLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5BdXRoZW50aWNhdGlvbkNhdGVnb3J5LkNhbGxiYWNrUmVjZWl2ZWRFdmVudEgAEm4KEnJlZGlyZWN0X2luaXRpYXRlZBgHIAEoCzJQLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5BdXRoZW50aWNhdGlvbkNhdGVnb3J5LlJlZGlyZWN0SW5pdGlhdGVkRXZlbnRIABJXCgZsb2dvdXQYCCABKAsyRS5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuQXV0aGVudGljYXRpb25DYXRlZ29yeS5Mb2dvdXRFdmVudEgAEmYKB2tleV9hcHAYCSABKAsyUy5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuQXV0aGVudGljYXRpb25DYXRlZ29yeS5LZXlBcHBBdXRoZW50aWNhdGlvbkV2ZW50SAAaswIKCkxvZ2luRXZlbnQSWQoLYXV0aF9tZXRob2QYASABKA4yRC5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuQXV0aGVudGljYXRpb25DYXRlZ29yeS5BdXRoTWV0aG9kEmMKC2F1dGhfc291cmNlGAIgASgOMkQub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLkF1dGhlbnRpY2F0aW9uQ2F0ZWdvcnkuQXV0aFNvdXJjZUII4tgYBCoCCAESXwoJdXNlcl90eXBlGAMgASgOMkIub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLkF1dGhlbnRpY2F0aW9uQ2F0ZWdvcnkuVXNlclR5cGVCCOLYGAQqAggBOgTo2BgBGr4CChFMb2dpbkZhaWx1cmVFdmVudBJZCgthdXRoX21ldGhvZBgBIAEoDjJELm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5BdXRoZW50aWNhdGlvbkNhdGVnb3J5LkF1dGhNZXRob2QSYwoLYXV0aF9zb3VyY2UYAiABKA4yRC5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuQXV0aGVudGljYXRpb25DYXRlZ29yeS5BdXRoU291cmNlQgji2BgEKgIIARJpCg5mYWlsdXJlX3JlYXNvbhgDIAEoDjJHLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5BdXRoZW50aWNhdGlvbkNhdGVnb3J5LkZhaWx1cmVSZWFzb25CCOLYGAQqAggBGq0DChFSZWdpc3RyYXRpb25FdmVudBJZCgthdXRoX21ldGhvZBgBIAEoDjJELm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5BdXRoZW50aWNhdGlvbkNhdGVnb3J5LkF1dGhNZXRob2QSFQoFZW1haWwYAiABKAlCBuLYGAIIARIzCgVwaG9uZRgDIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZUIG4tgYAggBEkMKCmZpcnN0X25hbWUYBCABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWVCEeLYGA0IARIJZmlyc3ROYW1lEkEKCWxhc3RfbmFtZRgFIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZUIQ4tgYDAgBEghsYXN0TmFtZRJjCgthdXRoX3NvdXJjZRgGIAEoDjJELm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5BdXRoZW50aWNhdGlvbkNhdGVnb3J5LkF1dGhTb3VyY2VCCOLYGAQqAggBOgTo2BgBGtoBChhSZWdpc3RyYXRpb25GYWlsdXJlRXZlbnQSWQoLYXV0aF9tZXRob2QYASABKA4yRC5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuQXV0aGVudGljYXRpb25DYXRlZ29yeS5BdXRoTWV0aG9kEmMKC2F1dGhfc291cmNlGAIgASgOMkQub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLkF1dGhlbnRpY2F0aW9uQ2F0ZWdvcnkuQXV0aFNvdXJjZUII4tgYBCoCCAEayAIKF0NsaWVudFJlZ2lzdHJhdGlvbkV2ZW50ElkKC2F1dGhfbWV0aG9kGAEgASgOMkQub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLkF1dGhlbnRpY2F0aW9uQ2F0ZWdvcnkuQXV0aE1ldGhvZBIVCgVlbWFpbBgCIAEoCUIG4tgYAggBEjMKBXBob25lGAMgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlQgbi2BgCCAESQwoKZmlyc3RfbmFtZRgEIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZUIR4tgYDQgBEglmaXJzdE5hbWUSQQoJbGFzdF9uYW1lGAUgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlQhDi2BgMCAESCGxhc3ROYW1lGrcCChVDYWxsYmFja1JlY2VpdmVkRXZlbnQSWQoLYXV0aF9tZXRob2QYASABKA4yRC5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuQXV0aGVudGljYXRpb25DYXRlZ29yeS5BdXRoTWV0aG9kEmMKC2F1dGhfc291cmNlGAIgASgOMkQub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLkF1dGhlbnRpY2F0aW9uQ2F0ZWdvcnkuQXV0aFNvdXJjZUII4tgYBCoCCAESXgoIcGxhdGZvcm0YAyABKA4yQi5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuQXV0aGVudGljYXRpb25DYXRlZ29yeS5QbGF0Zm9ybUII4tgYBCoCCAEauAIKFlJlZGlyZWN0SW5pdGlhdGVkRXZlbnQSWQoLYXV0aF9tZXRob2QYASABKA4yRC5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuQXV0aGVudGljYXRpb25DYXRlZ29yeS5BdXRoTWV0aG9kEmMKC2F1dGhfc291cmNlGAIgASgOMkQub2RfcHJvdG9zLmpvdXJuZXkuZGF0YS5jYXRlZ29yaWVzLkF1dGhlbnRpY2F0aW9uQ2F0ZWdvcnkuQXV0aFNvdXJjZUII4tgYBCoCCAESXgoIcGxhdGZvcm0YAyABKA4yQi5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuQXV0aGVudGljYXRpb25DYXRlZ29yeS5QbGF0Zm9ybUII4tgYBCoCCAEacgoLTG9nb3V0RXZlbnQSYwoLYXV0aF9zb3VyY2UYASABKA4yRC5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuQXV0aGVudGljYXRpb25DYXRlZ29yeS5BdXRoU291cmNlQgji2BgEKgIIARrTBwoZS2V5QXBwQXV0aGVudGljYXRpb25FdmVudBJ6CglvcGVyYXRpb24YASABKA4yXS5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuQXV0aGVudGljYXRpb25DYXRlZ29yeS5LZXlBcHBBdXRoZW50aWNhdGlvbkV2ZW50Lk9wZXJhdGlvbkII2tgYBBICCAESdgoHb3V0Y29tZRgCIAEoDjJbLm9kX3Byb3Rvcy5qb3VybmV5LmRhdGEuY2F0ZWdvcmllcy5BdXRoZW50aWNhdGlvbkNhdGVnb3J5LktleUFwcEF1dGhlbnRpY2F0aW9uRXZlbnQuT3V0Y29tZUII4tgYBCoCCAESYwoLYXV0aF9tZXRob2QYAyABKA4yRC5vZF9wcm90b3Muam91cm5leS5kYXRhLmNhdGVnb3JpZXMuQXV0aGVudGljYXRpb25DYXRlZ29yeS5BdXRoTWV0aG9kQgji2BgEKgIIASLkAQoJT3BlcmF0aW9uEhkKFU9QRVJBVElPTl9VTlNQRUNJRklFRBAAEh4KGkFDQ09VTlRfREVMRVRJT05fUkVRVUVTVEVEEAESHQoZRk9SR09UX1BBU1NXT1JEX1JFUVVFU1RFRBACEhwKGEdPT0dMRV9TSUdOX0lOX1JFUVVFU1RFRBADEgkKBUxPR0lOEAQSFQoRTUFHSUNfTElOS19PUEVORUQQBRIXChNNQUdJQ19MSU5LX1JFQ0VJVkVEEAYSFwoTTUFHSUNfTE9HSU5fU1VDQ0VTUxAHEgsKB1NJR05fVVAQCCL1AgoHT3V0Y29tZRIXChNPVVRDT01FX1VOU1BFQ0lGSUVEEAASCwoHU1VDQ0VTUxABEhIKDlRPS0VOX1JFQ0VJVkVEEAISEQoNSU5WQUxJRF9FTUFJTBADEhQKEElOVkFMSURfUEFTU1dPUkQQBBIdChlJTlZBTElEX0VNQUlMX09SX1BBU1NXT1JEEAUSFgoSQUxSRUFEWV9SRUdJU1RFUkVEEAYSFQoRU0VTU0lPTl9OT1RfRk9VTkQQBxINCglDQU5DRUxMRUQQCBIZChVBVVRIRU5USUNBVElPTl9GQUlMRUQQCRIYChRQUk9WSURFUl9BVVRIX0ZBSUxFRBAKEhEKDU5FVFdPUktfRVJST1IQCxIRCg1UT0tFTl9FWFBJUkVEEAwSEQoNVE9LRU5fTUlTU0lORxANEhQKEFVOU1VQUE9SVEVEX1BBVEgQDhITCg9SRURJUkVDVF9GQUlMRUQQDxIRCg1VTktOT1dOX0VSUk9SEBAigwEKCkF1dGhNZXRob2QSFgoSTUVUSE9EX1VOU1BFQ0lGSUVEEAASEgoORU1BSUxfUEFTU1dPUkQQARIICgRMSVRFEAISCgoGR09PR0xFEAMSDAoIRkFDRUJPT0sQBBIaChZTRVNTSU9OX0FMUkVBRFlfRVhJU1RTEAUSCQoFQVBQTEUQBiIxCgpBdXRoU291cmNlEhYKElNPVVJDRV9VTlNQRUNJRklFRBAAEgsKB0tFWV9BUFAQASJGCghVc2VyVHlwZRIZChVVU0VSX1RZUEVfVU5TUEVDSUZJRUQQABIMCghORVdfVVNFUhABEhEKDUVYSVNUSU5HX1VTRVIQAiLbAQoNRmFpbHVyZVJlYXNvbhIeChpGQUlMVVJFX1JFQVNPTl9VTlNQRUNJRklFRBAAEhQKEElOVkFMSURfUEFTU1dPUkQQARIQCgxVTktOT1dOX1VTRVIQAhIKCgZMT0NLRUQQAxINCglTVVNQRU5ERUQQBBILCgdERUxFVEVEEAUSDwoLT0FVVEhfRVJST1IQBhIJCgVPVEhFUhAHEhMKD1RPS0VOX05PVF9GT1VORBAIEhEKDVRPS0VOX0VYUElSRUQQCRIWChJUT0tFTl9BTFJFQURZX1VTRUQQCiItCghQbGF0Zm9ybRIYChRQTEFURk9STV9VTlNQRUNJRklFRBAAEgcKA1dFQhABQgcKBWV2ZW50QkNaQWdpdGh1Yi5jb20vb3BlbmRvb3ItbGFicy9jb2RlL2dvL3Byb3RvYnVmL2pvdXJuZXkvZGF0YS9jYXRlZ29yaWVzYgZwcm90bzM", [file_google_protobuf_wrappers, file_protobuf_journey_data_options_options]);

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory
 */
export type AuthenticationCategory = Message<"od_protos.journey.data.categories.AuthenticationCategory"> & {
  /**
   * @generated from oneof od_protos.journey.data.categories.AuthenticationCategory.event
   */
  event: {
    /**
     * authentication_login_event
     *
     * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.LoginEvent login = 1;
     */
    value: AuthenticationCategory_LoginEvent;
    case: "login";
  } | {
    /**
     * authentication_login_failure_event
     *
     * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.LoginFailureEvent login_failure = 2;
     */
    value: AuthenticationCategory_LoginFailureEvent;
    case: "loginFailure";
  } | {
    /**
     * authentication_registration_event
     *
     * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.RegistrationEvent registration = 3;
     */
    value: AuthenticationCategory_RegistrationEvent;
    case: "registration";
  } | {
    /**
     * authentication_registration_failure_event
     *
     * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.RegistrationFailureEvent registration_failure = 4;
     */
    value: AuthenticationCategory_RegistrationFailureEvent;
    case: "registrationFailure";
  } | {
    /**
     * authentication_client_registration_event
     *
     * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.ClientRegistrationEvent client_registration = 5;
     */
    value: AuthenticationCategory_ClientRegistrationEvent;
    case: "clientRegistration";
  } | {
    /**
     * authentication_callback_received_event
     *
     * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.CallbackReceivedEvent callback_received = 6;
     */
    value: AuthenticationCategory_CallbackReceivedEvent;
    case: "callbackReceived";
  } | {
    /**
     * authentication_redirect_initiated_event
     *
     * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.RedirectInitiatedEvent redirect_initiated = 7;
     */
    value: AuthenticationCategory_RedirectInitiatedEvent;
    case: "redirectInitiated";
  } | {
    /**
     * authentication_logout_event
     *
     * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.LogoutEvent logout = 8;
     */
    value: AuthenticationCategory_LogoutEvent;
    case: "logout";
  } | {
    /**
     * authentication_key_app_event
     *
     * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent key_app = 9;
     */
    value: AuthenticationCategory_KeyAppAuthenticationEvent;
    case: "keyApp";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory
 */
export type AuthenticationCategoryJson = {
  /**
   * authentication_login_event
   *
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.LoginEvent login = 1;
   */
  login?: AuthenticationCategory_LoginEventJson;

  /**
   * authentication_login_failure_event
   *
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.LoginFailureEvent login_failure = 2;
   */
  loginFailure?: AuthenticationCategory_LoginFailureEventJson;

  /**
   * authentication_registration_event
   *
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.RegistrationEvent registration = 3;
   */
  registration?: AuthenticationCategory_RegistrationEventJson;

  /**
   * authentication_registration_failure_event
   *
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.RegistrationFailureEvent registration_failure = 4;
   */
  registrationFailure?: AuthenticationCategory_RegistrationFailureEventJson;

  /**
   * authentication_client_registration_event
   *
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.ClientRegistrationEvent client_registration = 5;
   */
  clientRegistration?: AuthenticationCategory_ClientRegistrationEventJson;

  /**
   * authentication_callback_received_event
   *
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.CallbackReceivedEvent callback_received = 6;
   */
  callbackReceived?: AuthenticationCategory_CallbackReceivedEventJson;

  /**
   * authentication_redirect_initiated_event
   *
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.RedirectInitiatedEvent redirect_initiated = 7;
   */
  redirectInitiated?: AuthenticationCategory_RedirectInitiatedEventJson;

  /**
   * authentication_logout_event
   *
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.LogoutEvent logout = 8;
   */
  logout?: AuthenticationCategory_LogoutEventJson;

  /**
   * authentication_key_app_event
   *
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent key_app = 9;
   */
  keyApp?: AuthenticationCategory_KeyAppAuthenticationEventJson;
};

/**
 * Describes the message od_protos.journey.data.categories.AuthenticationCategory.
 * Use `create(AuthenticationCategorySchema)` to create a new message.
 */
export const AuthenticationCategorySchema: GenMessage<AuthenticationCategory, {jsonType: AuthenticationCategoryJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_authentication_category, 0);

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.LoginEvent
 */
export type AuthenticationCategory_LoginEvent = Message<"od_protos.journey.data.categories.AuthenticationCategory.LoginEvent"> & {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 1;
   */
  authMethod: AuthenticationCategory_AuthMethod;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthSource auth_source = 2;
   */
  authSource: AuthenticationCategory_AuthSource;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.UserType user_type = 3;
   */
  userType: AuthenticationCategory_UserType;
};

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.LoginEvent
 */
export type AuthenticationCategory_LoginEventJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 1;
   */
  authMethod?: AuthenticationCategory_AuthMethodJson;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthSource auth_source = 2;
   */
  authSource?: AuthenticationCategory_AuthSourceJson;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.UserType user_type = 3;
   */
  userType?: AuthenticationCategory_UserTypeJson;
};

/**
 * Describes the message od_protos.journey.data.categories.AuthenticationCategory.LoginEvent.
 * Use `create(AuthenticationCategory_LoginEventSchema)` to create a new message.
 */
export const AuthenticationCategory_LoginEventSchema: GenMessage<AuthenticationCategory_LoginEvent, {jsonType: AuthenticationCategory_LoginEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_authentication_category, 0, 0);

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.LoginFailureEvent
 */
export type AuthenticationCategory_LoginFailureEvent = Message<"od_protos.journey.data.categories.AuthenticationCategory.LoginFailureEvent"> & {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 1;
   */
  authMethod: AuthenticationCategory_AuthMethod;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthSource auth_source = 2;
   */
  authSource: AuthenticationCategory_AuthSource;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.FailureReason failure_reason = 3;
   */
  failureReason: AuthenticationCategory_FailureReason;
};

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.LoginFailureEvent
 */
export type AuthenticationCategory_LoginFailureEventJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 1;
   */
  authMethod?: AuthenticationCategory_AuthMethodJson;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthSource auth_source = 2;
   */
  authSource?: AuthenticationCategory_AuthSourceJson;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.FailureReason failure_reason = 3;
   */
  failureReason?: AuthenticationCategory_FailureReasonJson;
};

/**
 * Describes the message od_protos.journey.data.categories.AuthenticationCategory.LoginFailureEvent.
 * Use `create(AuthenticationCategory_LoginFailureEventSchema)` to create a new message.
 */
export const AuthenticationCategory_LoginFailureEventSchema: GenMessage<AuthenticationCategory_LoginFailureEvent, {jsonType: AuthenticationCategory_LoginFailureEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_authentication_category, 0, 1);

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.RegistrationEvent
 */
export type AuthenticationCategory_RegistrationEvent = Message<"od_protos.journey.data.categories.AuthenticationCategory.RegistrationEvent"> & {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 1;
   */
  authMethod: AuthenticationCategory_AuthMethod;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: google.protobuf.StringValue phone = 3;
   */
  phone?: string | undefined;

  /**
   * @generated from field: google.protobuf.StringValue first_name = 4;
   */
  firstName?: string | undefined;

  /**
   * @generated from field: google.protobuf.StringValue last_name = 5;
   */
  lastName?: string | undefined;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthSource auth_source = 6;
   */
  authSource: AuthenticationCategory_AuthSource;
};

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.RegistrationEvent
 */
export type AuthenticationCategory_RegistrationEventJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 1;
   */
  authMethod?: AuthenticationCategory_AuthMethodJson;

  /**
   * @generated from field: string email = 2;
   */
  email?: string;

  /**
   * @generated from field: google.protobuf.StringValue phone = 3;
   */
  phone?: StringValueJson;

  /**
   * @generated from field: google.protobuf.StringValue first_name = 4;
   */
  firstName?: StringValueJson;

  /**
   * @generated from field: google.protobuf.StringValue last_name = 5;
   */
  lastName?: StringValueJson;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthSource auth_source = 6;
   */
  authSource?: AuthenticationCategory_AuthSourceJson;
};

/**
 * Describes the message od_protos.journey.data.categories.AuthenticationCategory.RegistrationEvent.
 * Use `create(AuthenticationCategory_RegistrationEventSchema)` to create a new message.
 */
export const AuthenticationCategory_RegistrationEventSchema: GenMessage<AuthenticationCategory_RegistrationEvent, {jsonType: AuthenticationCategory_RegistrationEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_authentication_category, 0, 2);

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.RegistrationFailureEvent
 */
export type AuthenticationCategory_RegistrationFailureEvent = Message<"od_protos.journey.data.categories.AuthenticationCategory.RegistrationFailureEvent"> & {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 1;
   */
  authMethod: AuthenticationCategory_AuthMethod;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthSource auth_source = 2;
   */
  authSource: AuthenticationCategory_AuthSource;
};

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.RegistrationFailureEvent
 */
export type AuthenticationCategory_RegistrationFailureEventJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 1;
   */
  authMethod?: AuthenticationCategory_AuthMethodJson;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthSource auth_source = 2;
   */
  authSource?: AuthenticationCategory_AuthSourceJson;
};

/**
 * Describes the message od_protos.journey.data.categories.AuthenticationCategory.RegistrationFailureEvent.
 * Use `create(AuthenticationCategory_RegistrationFailureEventSchema)` to create a new message.
 */
export const AuthenticationCategory_RegistrationFailureEventSchema: GenMessage<AuthenticationCategory_RegistrationFailureEvent, {jsonType: AuthenticationCategory_RegistrationFailureEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_authentication_category, 0, 3);

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.ClientRegistrationEvent
 */
export type AuthenticationCategory_ClientRegistrationEvent = Message<"od_protos.journey.data.categories.AuthenticationCategory.ClientRegistrationEvent"> & {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 1;
   */
  authMethod: AuthenticationCategory_AuthMethod;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: google.protobuf.StringValue phone = 3;
   */
  phone?: string | undefined;

  /**
   * @generated from field: google.protobuf.StringValue first_name = 4;
   */
  firstName?: string | undefined;

  /**
   * @generated from field: google.protobuf.StringValue last_name = 5;
   */
  lastName?: string | undefined;
};

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.ClientRegistrationEvent
 */
export type AuthenticationCategory_ClientRegistrationEventJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 1;
   */
  authMethod?: AuthenticationCategory_AuthMethodJson;

  /**
   * @generated from field: string email = 2;
   */
  email?: string;

  /**
   * @generated from field: google.protobuf.StringValue phone = 3;
   */
  phone?: StringValueJson;

  /**
   * @generated from field: google.protobuf.StringValue first_name = 4;
   */
  firstName?: StringValueJson;

  /**
   * @generated from field: google.protobuf.StringValue last_name = 5;
   */
  lastName?: StringValueJson;
};

/**
 * Describes the message od_protos.journey.data.categories.AuthenticationCategory.ClientRegistrationEvent.
 * Use `create(AuthenticationCategory_ClientRegistrationEventSchema)` to create a new message.
 */
export const AuthenticationCategory_ClientRegistrationEventSchema: GenMessage<AuthenticationCategory_ClientRegistrationEvent, {jsonType: AuthenticationCategory_ClientRegistrationEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_authentication_category, 0, 4);

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.CallbackReceivedEvent
 */
export type AuthenticationCategory_CallbackReceivedEvent = Message<"od_protos.journey.data.categories.AuthenticationCategory.CallbackReceivedEvent"> & {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 1;
   */
  authMethod: AuthenticationCategory_AuthMethod;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthSource auth_source = 2;
   */
  authSource: AuthenticationCategory_AuthSource;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.Platform platform = 3;
   */
  platform: AuthenticationCategory_Platform;
};

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.CallbackReceivedEvent
 */
export type AuthenticationCategory_CallbackReceivedEventJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 1;
   */
  authMethod?: AuthenticationCategory_AuthMethodJson;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthSource auth_source = 2;
   */
  authSource?: AuthenticationCategory_AuthSourceJson;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.Platform platform = 3;
   */
  platform?: AuthenticationCategory_PlatformJson;
};

/**
 * Describes the message od_protos.journey.data.categories.AuthenticationCategory.CallbackReceivedEvent.
 * Use `create(AuthenticationCategory_CallbackReceivedEventSchema)` to create a new message.
 */
export const AuthenticationCategory_CallbackReceivedEventSchema: GenMessage<AuthenticationCategory_CallbackReceivedEvent, {jsonType: AuthenticationCategory_CallbackReceivedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_authentication_category, 0, 5);

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.RedirectInitiatedEvent
 */
export type AuthenticationCategory_RedirectInitiatedEvent = Message<"od_protos.journey.data.categories.AuthenticationCategory.RedirectInitiatedEvent"> & {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 1;
   */
  authMethod: AuthenticationCategory_AuthMethod;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthSource auth_source = 2;
   */
  authSource: AuthenticationCategory_AuthSource;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.Platform platform = 3;
   */
  platform: AuthenticationCategory_Platform;
};

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.RedirectInitiatedEvent
 */
export type AuthenticationCategory_RedirectInitiatedEventJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 1;
   */
  authMethod?: AuthenticationCategory_AuthMethodJson;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthSource auth_source = 2;
   */
  authSource?: AuthenticationCategory_AuthSourceJson;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.Platform platform = 3;
   */
  platform?: AuthenticationCategory_PlatformJson;
};

/**
 * Describes the message od_protos.journey.data.categories.AuthenticationCategory.RedirectInitiatedEvent.
 * Use `create(AuthenticationCategory_RedirectInitiatedEventSchema)` to create a new message.
 */
export const AuthenticationCategory_RedirectInitiatedEventSchema: GenMessage<AuthenticationCategory_RedirectInitiatedEvent, {jsonType: AuthenticationCategory_RedirectInitiatedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_authentication_category, 0, 6);

/**
 * Symmetric counterpart to LoginEvent. Emitted on every logout pathway
 * (user-initiated sign-out + server-side session revocation).
 *
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.LogoutEvent
 */
export type AuthenticationCategory_LogoutEvent = Message<"od_protos.journey.data.categories.AuthenticationCategory.LogoutEvent"> & {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthSource auth_source = 1;
   */
  authSource: AuthenticationCategory_AuthSource;
};

/**
 * Symmetric counterpart to LoginEvent. Emitted on every logout pathway
 * (user-initiated sign-out + server-side session revocation).
 *
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.LogoutEvent
 */
export type AuthenticationCategory_LogoutEventJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthSource auth_source = 1;
   */
  authSource?: AuthenticationCategory_AuthSourceJson;
};

/**
 * Describes the message od_protos.journey.data.categories.AuthenticationCategory.LogoutEvent.
 * Use `create(AuthenticationCategory_LogoutEventSchema)` to create a new message.
 */
export const AuthenticationCategory_LogoutEventSchema: GenMessage<AuthenticationCategory_LogoutEvent, {jsonType: AuthenticationCategory_LogoutEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_authentication_category, 0, 7);

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent
 */
export type AuthenticationCategory_KeyAppAuthenticationEvent = Message<"od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent"> & {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent.Operation operation = 1;
   */
  operation: AuthenticationCategory_KeyAppAuthenticationEvent_Operation;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent.Outcome outcome = 2;
   */
  outcome: AuthenticationCategory_KeyAppAuthenticationEvent_Outcome;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 3;
   */
  authMethod: AuthenticationCategory_AuthMethod;
};

/**
 * @generated from message od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent
 */
export type AuthenticationCategory_KeyAppAuthenticationEventJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent.Operation operation = 1;
   */
  operation?: AuthenticationCategory_KeyAppAuthenticationEvent_OperationJson;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent.Outcome outcome = 2;
   */
  outcome?: AuthenticationCategory_KeyAppAuthenticationEvent_OutcomeJson;

  /**
   * @generated from field: od_protos.journey.data.categories.AuthenticationCategory.AuthMethod auth_method = 3;
   */
  authMethod?: AuthenticationCategory_AuthMethodJson;
};

/**
 * Describes the message od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent.
 * Use `create(AuthenticationCategory_KeyAppAuthenticationEventSchema)` to create a new message.
 */
export const AuthenticationCategory_KeyAppAuthenticationEventSchema: GenMessage<AuthenticationCategory_KeyAppAuthenticationEvent, {jsonType: AuthenticationCategory_KeyAppAuthenticationEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_authentication_category, 0, 8);

/**
 * @generated from enum od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent.Operation
 */
export enum AuthenticationCategory_KeyAppAuthenticationEvent_Operation {
  /**
   * @generated from enum value: OPERATION_UNSPECIFIED = 0;
   */
  OPERATION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACCOUNT_DELETION_REQUESTED = 1;
   */
  ACCOUNT_DELETION_REQUESTED = 1,

  /**
   * @generated from enum value: FORGOT_PASSWORD_REQUESTED = 2;
   */
  FORGOT_PASSWORD_REQUESTED = 2,

  /**
   * @generated from enum value: GOOGLE_SIGN_IN_REQUESTED = 3;
   */
  GOOGLE_SIGN_IN_REQUESTED = 3,

  /**
   * @generated from enum value: LOGIN = 4;
   */
  LOGIN = 4,

  /**
   * @generated from enum value: MAGIC_LINK_OPENED = 5;
   */
  MAGIC_LINK_OPENED = 5,

  /**
   * @generated from enum value: MAGIC_LINK_RECEIVED = 6;
   */
  MAGIC_LINK_RECEIVED = 6,

  /**
   * @generated from enum value: MAGIC_LOGIN_SUCCESS = 7;
   */
  MAGIC_LOGIN_SUCCESS = 7,

  /**
   * @generated from enum value: SIGN_UP = 8;
   */
  SIGN_UP = 8,
}

/**
 * @generated from enum od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent.Operation
 */
export type AuthenticationCategory_KeyAppAuthenticationEvent_OperationJson = "OPERATION_UNSPECIFIED" | "ACCOUNT_DELETION_REQUESTED" | "FORGOT_PASSWORD_REQUESTED" | "GOOGLE_SIGN_IN_REQUESTED" | "LOGIN" | "MAGIC_LINK_OPENED" | "MAGIC_LINK_RECEIVED" | "MAGIC_LOGIN_SUCCESS" | "SIGN_UP";

/**
 * Describes the enum od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent.Operation.
 */
export const AuthenticationCategory_KeyAppAuthenticationEvent_OperationSchema: GenEnum<AuthenticationCategory_KeyAppAuthenticationEvent_Operation, AuthenticationCategory_KeyAppAuthenticationEvent_OperationJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_authentication_category, 0, 8, 0);

/**
 * @generated from enum od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent.Outcome
 */
export enum AuthenticationCategory_KeyAppAuthenticationEvent_Outcome {
  /**
   * @generated from enum value: OUTCOME_UNSPECIFIED = 0;
   */
  OUTCOME_UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * @generated from enum value: TOKEN_RECEIVED = 2;
   */
  TOKEN_RECEIVED = 2,

  /**
   * @generated from enum value: INVALID_EMAIL = 3;
   */
  INVALID_EMAIL = 3,

  /**
   * @generated from enum value: INVALID_PASSWORD = 4;
   */
  INVALID_PASSWORD = 4,

  /**
   * @generated from enum value: INVALID_EMAIL_OR_PASSWORD = 5;
   */
  INVALID_EMAIL_OR_PASSWORD = 5,

  /**
   * @generated from enum value: ALREADY_REGISTERED = 6;
   */
  ALREADY_REGISTERED = 6,

  /**
   * @generated from enum value: SESSION_NOT_FOUND = 7;
   */
  SESSION_NOT_FOUND = 7,

  /**
   * @generated from enum value: CANCELLED = 8;
   */
  CANCELLED = 8,

  /**
   * @generated from enum value: AUTHENTICATION_FAILED = 9;
   */
  AUTHENTICATION_FAILED = 9,

  /**
   * @generated from enum value: PROVIDER_AUTH_FAILED = 10;
   */
  PROVIDER_AUTH_FAILED = 10,

  /**
   * @generated from enum value: NETWORK_ERROR = 11;
   */
  NETWORK_ERROR = 11,

  /**
   * @generated from enum value: TOKEN_EXPIRED = 12;
   */
  TOKEN_EXPIRED = 12,

  /**
   * @generated from enum value: TOKEN_MISSING = 13;
   */
  TOKEN_MISSING = 13,

  /**
   * @generated from enum value: UNSUPPORTED_PATH = 14;
   */
  UNSUPPORTED_PATH = 14,

  /**
   * @generated from enum value: REDIRECT_FAILED = 15;
   */
  REDIRECT_FAILED = 15,

  /**
   * @generated from enum value: UNKNOWN_ERROR = 16;
   */
  UNKNOWN_ERROR = 16,
}

/**
 * @generated from enum od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent.Outcome
 */
export type AuthenticationCategory_KeyAppAuthenticationEvent_OutcomeJson = "OUTCOME_UNSPECIFIED" | "SUCCESS" | "TOKEN_RECEIVED" | "INVALID_EMAIL" | "INVALID_PASSWORD" | "INVALID_EMAIL_OR_PASSWORD" | "ALREADY_REGISTERED" | "SESSION_NOT_FOUND" | "CANCELLED" | "AUTHENTICATION_FAILED" | "PROVIDER_AUTH_FAILED" | "NETWORK_ERROR" | "TOKEN_EXPIRED" | "TOKEN_MISSING" | "UNSUPPORTED_PATH" | "REDIRECT_FAILED" | "UNKNOWN_ERROR";

/**
 * Describes the enum od_protos.journey.data.categories.AuthenticationCategory.KeyAppAuthenticationEvent.Outcome.
 */
export const AuthenticationCategory_KeyAppAuthenticationEvent_OutcomeSchema: GenEnum<AuthenticationCategory_KeyAppAuthenticationEvent_Outcome, AuthenticationCategory_KeyAppAuthenticationEvent_OutcomeJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_authentication_category, 0, 8, 1);

/**
 * @generated from enum od_protos.journey.data.categories.AuthenticationCategory.AuthMethod
 */
export enum AuthenticationCategory_AuthMethod {
  /**
   * @generated from enum value: METHOD_UNSPECIFIED = 0;
   */
  METHOD_UNSPECIFIED = 0,

  /**
   * @generated from enum value: EMAIL_PASSWORD = 1;
   */
  EMAIL_PASSWORD = 1,

  /**
   * @generated from enum value: LITE = 2;
   */
  LITE = 2,

  /**
   * @generated from enum value: GOOGLE = 3;
   */
  GOOGLE = 3,

  /**
   * @generated from enum value: FACEBOOK = 4;
   */
  FACEBOOK = 4,

  /**
   * @generated from enum value: SESSION_ALREADY_EXISTS = 5;
   */
  SESSION_ALREADY_EXISTS = 5,

  /**
   * @generated from enum value: APPLE = 6;
   */
  APPLE = 6,
}

/**
 * @generated from enum od_protos.journey.data.categories.AuthenticationCategory.AuthMethod
 */
export type AuthenticationCategory_AuthMethodJson = "METHOD_UNSPECIFIED" | "EMAIL_PASSWORD" | "LITE" | "GOOGLE" | "FACEBOOK" | "SESSION_ALREADY_EXISTS" | "APPLE";

/**
 * Describes the enum od_protos.journey.data.categories.AuthenticationCategory.AuthMethod.
 */
export const AuthenticationCategory_AuthMethodSchema: GenEnum<AuthenticationCategory_AuthMethod, AuthenticationCategory_AuthMethodJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_authentication_category, 0, 0);

/**
 * @generated from enum od_protos.journey.data.categories.AuthenticationCategory.AuthSource
 */
export enum AuthenticationCategory_AuthSource {
  /**
   * @generated from enum value: SOURCE_UNSPECIFIED = 0;
   */
  SOURCE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: KEY_APP = 1;
   */
  KEY_APP = 1,
}

/**
 * @generated from enum od_protos.journey.data.categories.AuthenticationCategory.AuthSource
 */
export type AuthenticationCategory_AuthSourceJson = "SOURCE_UNSPECIFIED" | "KEY_APP";

/**
 * Describes the enum od_protos.journey.data.categories.AuthenticationCategory.AuthSource.
 */
export const AuthenticationCategory_AuthSourceSchema: GenEnum<AuthenticationCategory_AuthSource, AuthenticationCategory_AuthSourceJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_authentication_category, 0, 1);

/**
 * @generated from enum od_protos.journey.data.categories.AuthenticationCategory.UserType
 */
export enum AuthenticationCategory_UserType {
  /**
   * @generated from enum value: USER_TYPE_UNSPECIFIED = 0;
   */
  USER_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: NEW_USER = 1;
   */
  NEW_USER = 1,

  /**
   * @generated from enum value: EXISTING_USER = 2;
   */
  EXISTING_USER = 2,
}

/**
 * @generated from enum od_protos.journey.data.categories.AuthenticationCategory.UserType
 */
export type AuthenticationCategory_UserTypeJson = "USER_TYPE_UNSPECIFIED" | "NEW_USER" | "EXISTING_USER";

/**
 * Describes the enum od_protos.journey.data.categories.AuthenticationCategory.UserType.
 */
export const AuthenticationCategory_UserTypeSchema: GenEnum<AuthenticationCategory_UserType, AuthenticationCategory_UserTypeJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_authentication_category, 0, 2);

/**
 * @generated from enum od_protos.journey.data.categories.AuthenticationCategory.FailureReason
 */
export enum AuthenticationCategory_FailureReason {
  /**
   * @generated from enum value: FAILURE_REASON_UNSPECIFIED = 0;
   */
  FAILURE_REASON_UNSPECIFIED = 0,

  /**
   * @generated from enum value: INVALID_PASSWORD = 1;
   */
  INVALID_PASSWORD = 1,

  /**
   * @generated from enum value: UNKNOWN_USER = 2;
   */
  UNKNOWN_USER = 2,

  /**
   * @generated from enum value: LOCKED = 3;
   */
  LOCKED = 3,

  /**
   * @generated from enum value: SUSPENDED = 4;
   */
  SUSPENDED = 4,

  /**
   * @generated from enum value: DELETED = 5;
   */
  DELETED = 5,

  /**
   * @generated from enum value: OAUTH_ERROR = 6;
   */
  OAUTH_ERROR = 6,

  /**
   * @generated from enum value: OTHER = 7;
   */
  OTHER = 7,

  /**
   * @generated from enum value: TOKEN_NOT_FOUND = 8;
   */
  TOKEN_NOT_FOUND = 8,

  /**
   * @generated from enum value: TOKEN_EXPIRED = 9;
   */
  TOKEN_EXPIRED = 9,

  /**
   * @generated from enum value: TOKEN_ALREADY_USED = 10;
   */
  TOKEN_ALREADY_USED = 10,
}

/**
 * @generated from enum od_protos.journey.data.categories.AuthenticationCategory.FailureReason
 */
export type AuthenticationCategory_FailureReasonJson = "FAILURE_REASON_UNSPECIFIED" | "INVALID_PASSWORD" | "UNKNOWN_USER" | "LOCKED" | "SUSPENDED" | "DELETED" | "OAUTH_ERROR" | "OTHER" | "TOKEN_NOT_FOUND" | "TOKEN_EXPIRED" | "TOKEN_ALREADY_USED";

/**
 * Describes the enum od_protos.journey.data.categories.AuthenticationCategory.FailureReason.
 */
export const AuthenticationCategory_FailureReasonSchema: GenEnum<AuthenticationCategory_FailureReason, AuthenticationCategory_FailureReasonJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_authentication_category, 0, 3);

/**
 * @generated from enum od_protos.journey.data.categories.AuthenticationCategory.Platform
 */
export enum AuthenticationCategory_Platform {
  /**
   * @generated from enum value: PLATFORM_UNSPECIFIED = 0;
   */
  PLATFORM_UNSPECIFIED = 0,

  /**
   * @generated from enum value: WEB = 1;
   */
  WEB = 1,
}

/**
 * @generated from enum od_protos.journey.data.categories.AuthenticationCategory.Platform
 */
export type AuthenticationCategory_PlatformJson = "PLATFORM_UNSPECIFIED" | "WEB";

/**
 * Describes the enum od_protos.journey.data.categories.AuthenticationCategory.Platform.
 */
export const AuthenticationCategory_PlatformSchema: GenEnum<AuthenticationCategory_Platform, AuthenticationCategory_PlatformJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_authentication_category, 0, 4);

